import { render, staticRenderFns } from "./EmptyPlug.vue?vue&type=template&id=0c33b486&scoped=true"
import script from "./EmptyPlug.vue?vue&type=script&lang=js"
export * from "./EmptyPlug.vue?vue&type=script&lang=js"
import style0 from "./EmptyPlug.vue?vue&type=style&index=0&id=0c33b486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33b486",
  null
  
)

export default component.exports